import { ClassroomRepository } from '@xq/infrastructure';

export class GetPhaseJournalByIdUseCase {
  static execute(classroomId: string, id: string) {
    const classroomRepo = new ClassroomRepository();

    return classroomRepo.getPhaseJournalById(classroomId, id);
  }
}
